function readProxyUrlTemplate (): string | undefined {
  return process.env.VUE_APP_PROXY_URL
}

export function resolveCountryGatewayOrigin (
  country: string,
  apiUrl?: string
): string {
  const proxyTemplate = readProxyUrlTemplate()
  if (proxyTemplate?.includes('{country}')) {
    return proxyTemplate.replace('{country}', country).replace(/\/+$/, '')
  }

  if (apiUrl) {
    const resolvedApiUrl = apiUrl.includes('{country}')
      ? apiUrl.replace('{country}', country)
      : apiUrl
    if (/\/api\/?$/i.test(resolvedApiUrl)) {
      return resolvedApiUrl.replace(/\/api\/?$/i, '')
    }
    return resolvedApiUrl.replace(/\/+$/, '')
  }

  if (typeof window !== 'undefined') {
    return window.location.origin
      .replace('://', `://${country}.`)
      .replace(/\/+$/, '')
  }

  throw new Error('Cannot resolve country gateway origin')
}
